/**
 * Deterministic character names (drawn from the save's RNG, so the same seed
 * meets the same people). Mid-century flavor per the atompunk direction.
 */

import { drawInt, type RngState } from "@/systems/rng";

const FIRST = [
  "Marv", "Doris", "Chet", "Lois", "Gene", "Ruth", "Wally", "Fern",
  "Buzz", "Opal", "Ray", "Vera", "Stan", "June", "Earl", "Patsy",
  "Dwight", "Ida", "Vern", "Marge", "Cliff", "Enid", "Lyle", "Bea",
];
const LAST_INITIAL = "BCDFGHJKLMNPRSTW";

export function drawName(rng: RngState): string {
  const first = FIRST[drawInt(rng, FIRST.length)]!;
  const initial = LAST_INITIAL[drawInt(rng, LAST_INITIAL.length)]!;
  return `${first} ${initial}.`;
}
